<template>
  <main>
    <p class="history-count">Showing the last 30 records.</p>
    <h5 class="mt-3 mb-3">Import History</h5>
    <div class="history">
      <div v-for="h in history">
        <div class="row">

        <div class="col-6">
          <b>Status:</b>  {{h.status}}. <i v-if="h.status == 'running'" class="fas fa-cog fa-spin"></i><br/>
          <b>Last log:</b>  {{h.status_update.split(',').slice(-1).pop()}}.
        </div>
				<div class="col-6">
          <b>Started:</b>  {{$moment(h.created_at).calendar(null,{sameElse: 'lll'})}}.<br/>
          <b v-if="h.status == 'running'">Last update:</b> <b v-else>Finished:</b> {{$moment(h.updated_at).calendar(null,{sameElse: 'lll'})}}.
        </div>
      </div>

      </div>
    </div>
  </main>
</template>

<script>
export default {
	name: 'Import',
	data: function() {
		return {
			history: [],
		};
	},
	methods: {
		refresh: function() {
			this.$axios.get(`/script/import`)
				.then((response) => {
					// console.log(response.data.data);

					this.history = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					//
				});
		},
	},
	mounted: function() {
		this.refresh();
		setInterval(() => {
			this.refresh();
		}, 3000);
	},
};
</script>

<style scoped>
.history {
  margin-left: -15px;
}
.history > div{
  border-top: 1px solid #efefef;
  padding: 15px;
}
.history-count{
  position: absolute;
  right: 30px;
  margin: 0;
}
</style>
